import { render, staticRenderFns } from "./referansmizan.vue?vue&type=template&id=d88a81d4&"
import script from "./referansmizan.vue?vue&type=script&lang=js&"
export * from "./referansmizan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports